import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionPlansComponent } from 'src/app/subscription-plans/subscription-plans.component';
import * as moment from 'moment';
// import { AddNewCardComponent } from 'src/app/add-new-card/add-new-card.component';
import { PaymentsService } from 'src/app/services/payments.service';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
import { SubscriptionCancelConfirmationComponent } from 'src/app/subscription-cancel-confirmation/subscription-cancel-confirmation.component';
import { SubscriptonHistoryComponent } from 'src/app/subscripton-history/subscripton-history.component';

@Component({
  selector: 'app-configuration-new',
  templateUrl: './configuration-new.component.html',
  styleUrls: ['./configuration-new.component.scss']
})
export class ConfigurationNewComponent implements OnInit {
  _: any = _
	bgTextColor = "#000000";
	plans = []
	selectedPlan;
	orgName = localStorage.getItem("organizationName");
  userEmail = localStorage.getItem("email");
  userId = localStorage.getItem("userId");
  planChanged = false;
	subscription:any = {}
  curentSubscriptions: any = [];
  scheduledSubscriptions: any = [];
  stripeSubscriptions: any = [];
  history: Array<any> = [];

  // Payments related vars
  stripe;
  stripeSecret: any;
  elements: any;

  dialogref: any = '';
  planChangeDialogRef: any = '';
  @ViewChild("confirmationDialog") confirmChange: TemplateRef<any>;
  @ViewChild("planChangeDialog") planChangeDialog: TemplateRef<any>;

  constructor(
	private _sharedService: SharedService,
    public dialog: MatDialog,
    private _paymentService: PaymentsService,
    public _loader: LoaderService,
    private _dialog: MatDialog
  ) { }
  ngOnInit() {
    this.onInit();
  }
  onInit(): void {
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    // let promises = [this._paymentService.getSubscriptions().toPromise()];
    let promises = [this._paymentService.getSubscriptions().toPromise(), this._sharedService.getSubscriptionDetails().toPromise(), this._paymentService.getAllSubscriptions().toPromise()];
    Promise.all(promises)
      .then((result) => {
        if(result[0] && result[0]['success']) {
          this.plans = result[0]['subscriptions'];
          this.plans = _.orderBy(this.plans, 'price')
        } else {
          this.plans = [];
        }

        if(result[1] && result[1]['success']) {
          this.subscription = result[1]['subscription'];
          if(_.isEmpty(this.subscription)) {
            console.log("No scubscription");
            return;
          }
          this.curentSubscriptions = result[1]['subscriptions'];
          this.curentSubscriptions = _.map(this.curentSubscriptions, (subscription: any) => {
            let plan = _.find(this.plans, (plan) => {
              if(plan['id'] == subscription['price_id']) {
                return plan;
              }
            });
            subscription.plan = plan;
            subscription.billing_date = moment(subscription['billing_date']).format("MMM DD, YYYY");
            subscription.next_billing_date = moment(subscription['next_billing_date']).format("MMM DD, YYYY");
            return subscription;
          })
          // let plan = _.find(this.plans, (plan: any) => {
          //   return plan.id == this.subscription.price_id;
          // })
          // this.subscription['name'] = plan['name'];
          // this.subscription['price'] = plan['price'];
          // this.subscription['billingDate'] = moment(this.subscription['billing_date']).format("MMM DD, YYYY")
          // this.subscription['nextBillingDate'] = moment(this.subscription['next_billing_date']).format("MMM DD, YYYY")
        }

        if(result[2] && result[2]['success']) {
          this.scheduledSubscriptions = result[2]['subscriptionSchedules'];
          this.stripeSubscriptions = result[2]['subscriptions'];

          let localSubscriptions = result[2]['localSubscriptions'];
          let localUpcomingSubscriptions = result[2]['localUpcomingSubscriptions'];

          this.stripeSubscriptions = localSubscriptions;
          this.scheduledSubscriptions = localUpcomingSubscriptions;
          this.history = result[2]['history'];

          this.stripeSubscriptions = _.map(this.stripeSubscriptions, (subscription: any) => {
            let plan = _.find(this.plans, (plan) => {
              if(plan['id'] == subscription['price_id']) {
                return plan;
              }
            });
            subscription.plan = plan;
            subscription.billing_date = moment(subscription['start']).format("MMM DD, YYYY");
            subscription.next_billing_date = moment(subscription['end']).format("MMM DD, YYYY");

            if(!_.isEmpty(subscription['cancel_at'])) {
              let today = moment(new Date());
              let cancellingDate = moment(subscription['cancel_at']);

              let diff = cancellingDate.diff(today, 'days');
              if(diff <= 5) {
                subscription['colorStatus'] = 'orange';
              }
              if(subscription['cancel_at']) {
                subscription['colorStatus'] = 'red';
              }
              subscription['cancel_at'] = moment(subscription['cancel_at']).format("MMM DD, YYYY");
              
              

              
            }
            return subscription;
          })

          this.scheduledSubscriptions = _.map(this.scheduledSubscriptions, (subscription: any) => {
            let plan = _.find(this.plans, (plan) => {
              if(plan['id'] == subscription['price_id']) {
                return plan;
              }
            });
            subscription.plan = plan;
            subscription.billing_date = moment(subscription['start']).format("MMM DD, YYYY");
            subscription.next_billing_date = moment(subscription['end']).format("MMM DD, YYYY");
            return subscription;
          })
        }
      })
  }

  onChangePlan() {
    let dialogRef = this.dialog.open(SubscriptionPlansComponent, {
      closeOnNavigation: true,
      data: {
        plans: this.plans,
        present_plan: this.subscription
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(_.isEmpty(result)) {
        return;
      }
      this.onSelectingPlan(result['plan'])
    })
  }

  onSelectingPlan(plan: any) {
    this.selectedPlan = plan;
    this.planChanged = true;
    
    if(!this.subscription) {
      return;
    }
    let currentSubscription = this.stripeSubscriptions[0];
    let { price_id, subscription_id, customer_id } = currentSubscription;
    if(!_.isEmpty(this.selectedPlan) && !this.planChanged) {
      // No Plan got changed
      console.log("Plan not changed");
      return;
    }
    this._paymentService.createUpcomingSubscription({
      user_id: this.userId,
      user_email: this.userEmail,
      price_id: price_id,
      subscription_id: subscription_id,
      customer_id: customer_id,
      new_price_id: this.selectedPlan['id']
    }).subscribe((response: any) => {
      if(response['success']) {
        this.planChanged = false;
        this.onInit();
      }
    })
  }

  onSubscription() {
    let currentUrl =  window.location.href;
    let planId = this.selectedPlan.id;
    let customerId = this.subscription['customer_id']
    
    this._paymentService.createPaymentSession({
      planId,
      currentUrl,
      plam: this.selectedPlan,
      userId: this.userId,
      customer: customerId,
      userEmail: this.userEmail
    }).subscribe((response) => {
      if(response['success']) {
        window.location.href = response['url']
      }
    }, (error) => {
      console.error(error)
    })
  }

  onCancelSubscription(id) {
    let dialogRef = this.dialog.open(SubscriptionCancelConfirmationComponent, {
      width: '500px',
      autoFocus  : false,
      closeOnNavigation: true,
      data: {
        message: "Are you sure want to cancel the subscription?"
      }
    })

    dialogRef.afterClosed().subscribe((result) => {
      if(result && result == true) {
        this._paymentService.cancelSubscription(id).subscribe((response: any) => {
          if(response['success']) {
            this._sharedService.openSnackBar(response['message']);
            this.onInit()
          } else {
            this.subscription = [];
            this._sharedService.openSnackBar(response['message']);
          }
        })
      }
    })
  }
  onCancelChangingSubscription() {
    this.selectedPlan = {};
    this.planChanged = false;
    this.onInit()
  }

  // For Changing upcoming subscription
  onSubscriptionChange() {
    let planId = this.selectedPlan.id;
    let customerId = this.subscription['customer_id'];
    let org = localStorage.getItem("organization");
    let user = localStorage.getItem("userId");
    
    this._paymentService.createUpcomingSubscription({
      subscription_id: this.stripeSubscriptions[0]['id'],
      new_price_id: planId,
      customer_id: customerId,
      org_id: org,
      user_id: user,
      price_id: this.subscription['price_id']
    }).subscribe((response) => {
      if(response['success']) {
        this.planChanged = false;
        this.onInit();
      }
    }, (error) => {
      console.error(error)
    })
  }

  onCancelUpcomingSubscriptionChange(id) {
    // this.dialogref = this.dialog.open(this.confirmChange, 
    //   {
    //     maxHeight: "50vh",
    //     width: "450px",
    //     disableClose: true,
    //   }
    // )

    // this.dialogref.afterClosed().subscribe((response: any) => {
      let payload = {
        resume: true,
        subscriptionId: this.stripeSubscriptions[0]['subscription_id']
      };
      this._paymentService.cancelUpcomingSubscription(id, payload).subscribe((response: any) => {
        if(response['success']) {
          this.onInit();
        }
      }, (error) => {
        console.error(error)
      })
    // })
  }

  onUpdateUpcomingSubscription(id: string) {
    this.planChangeDialogRef = this.dialog.open(this.planChangeDialog);

    this.planChangeDialogRef.afterClosed().subscribe((response: any) => {
      if(!_.isEmpty(response)) {
        // { user_id, customer_id, new_price_id, org_id }
        let payload = {
          user_id: this.userId,
          org_id: localStorage.getItem("organization"),
          customer_id: this.subscription['customer_id'],
          new_price_id: response['id']
        }
        this._paymentService.updateUpcomingSubscription(id, payload).subscribe((response: any) => {
            if(response['success']) {
              this.onInit();
            }
        }, (error) => {
          console.error(error)
        })
      }
    })
  }

  onImmediateCancelSubscription(id) {
    let dialogRef = this.dialog.open(SubscriptionCancelConfirmationComponent, {
      width: '500px',
      autoFocus  : false,
      closeOnNavigation: true,
      data: {
        message: "Are you sure want to end the subscription Immediately?"
      }
    })

    dialogRef.afterClosed().subscribe((result) => {
      if(result && result == true) {
        this._paymentService.cancelSubscriptionImmediatelyAndRefund(id).subscribe((response: any) => {
          if(response['success']) {
            this._sharedService.openSnackBar(response['message']);
            this._loader.changeLoadingVisibility(true);
            setTimeout(() => {
              this.onInit()
              this._loader.changeLoadingVisibility(false);
            }, 2000)
          } else {
            this.subscription = [];
            this._sharedService.openSnackBar(response['message']);
          }
        })
      }
    })
  }

  onShowSubscriptionHistory() {
    this.dialog.open(SubscriptonHistoryComponent, {
      width: '700px',
      autoFocus  : false,
      closeOnNavigation: true,
      data: {
        history: this.history
      }
    })
  }
}
